import { render } from "./QuestionsPane.vue?vue&type=template&id=baefc9e4&scoped=true&lang=pug"
import script from "./QuestionsPane.vue?vue&type=script&lang=js"
export * from "./QuestionsPane.vue?vue&type=script&lang=js"

import "./QuestionsPane.vue?vue&type=style&index=0&id=baefc9e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baefc9e4"]])

export default __exports__